import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ProfileReducer from "./auth/profile/reducer";

// Dashboard CRM
import DashboardReducer from "./dashboard/reducer";

//ChatGPT
import ChatGPTReducer from "./chatgpt/reducer";

// User
import UserReducer from "./user/reducer";

// Role
import RoleReducer from "./role/reducer";

// Global
import GlobalReducer from "./global/reducer";

// User Admin
import AdminReducer from "./admin/reducer";

// Facility
import FacilityReducer from "./facility/reducer";

// Package Sticker
import { PushNotiReducer } from "./pushNoti/reducer";

// Agency Management
import AgencyReducer from "./agency/reducer";
import AgencyCampaignReducer from "./agencyPrepayment/reducer";
import AgencyTrackingLogReducer from "./agencyTrackingLog/reducer";

// Push Notification
import PushNotification from "./push-notification/reducer";

// RedeemCode Management
import RedeemCodeReducer from "./redeemCode/reducer";
import RedeemCodeUsageReducer from "./redeemCodeUsage/reducer";

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  Account: AccountReducer,
  ForgetPassword: ForgetPasswordReducer,
  Profile: ProfileReducer,
  Dashboard: DashboardReducer,
  ChatGPT: ChatGPTReducer,
  User: UserReducer,
  Role: RoleReducer,
  Global: GlobalReducer,
  Admin: AdminReducer,

  Facility: FacilityReducer,

  PushNoti: PushNotiReducer,

  Agency: AgencyReducer,
  AgencyPrepayment: AgencyCampaignReducer,
  AgencyTrackingLog: AgencyTrackingLogReducer,

  PushNotification: PushNotification,
  RedeemCode: RedeemCodeReducer,
  RedeemCodeUsage: RedeemCodeUsageReducer,
});

export default rootReducer;
